var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.767 14.448 11.565 24.65l2.836 2.836 15.586-15.585v48.586h4.026V11.901L49.6 27.487l2.836-2.838-10.202-10.202C36.62 8.836 32.017 4.245 32 4.245s-4.622 4.591-10.233 10.203",
    clipRule: "evenodd"
  })));
};
export { SvgArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjc2NzIgMTQuNDQ3NUwxMS41NjQ5IDI0LjY0OTlMMTQuNDAxMyAyNy40ODYyTDI5Ljk4NzEgMTEuOTAwOFY2MC40ODcxSDM0LjAxMzFWMTEuOTAwOEw0OS41OTkxIDI3LjQ4NjVMNTIuNDM0NiAyNC42NDkxTDQyLjIzMjYgMTQuNDQ3MUMzNi42MjE0IDguODM1OTggMzIuMDE2NyA0LjI0NTEyIDMxLjk5OTkgNC4yNDUxMkMzMS45ODMyIDQuMjQ1MTIgMjcuMzc4NCA4LjgzNjE2IDIxLjc2NzIgMTQuNDQ3NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";